// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: excel/payload/ExcelPayloadPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ApiResultPayload } from "../../common/model/ApiResultCodePt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.excel.payload";

/**
 * 엑셀 종류
 *
 * 종류가 곧 「무엇을 뽑는가」다. 시트명 · 컬럼 · 행 조회가 이 값 하나로 갈린다.
 */
export enum ExcelKindPayload {
  EXCEL_KIND_UNKNOWN = 0,
  /** EXCEL_KIND_ENTRY_PLAYER - 대회의 신청 선수 목록 (체육관 순으로 정렬한 한 시트) */
  EXCEL_KIND_ENTRY_PLAYER = 1,
  /** EXCEL_KIND_BRACKET - 대회의 1라운드 대진표 (경기 · 종목 · 부 · 성별 · 체급 · 홍코너 · 청코너) */
  EXCEL_KIND_BRACKET = 2,
  UNRECOGNIZED = -1,
}

export function excelKindPayloadFromJSON(object: any): ExcelKindPayload {
  switch (object) {
    case 0:
    case "EXCEL_KIND_UNKNOWN":
      return ExcelKindPayload.EXCEL_KIND_UNKNOWN;
    case 1:
    case "EXCEL_KIND_ENTRY_PLAYER":
      return ExcelKindPayload.EXCEL_KIND_ENTRY_PLAYER;
    case 2:
    case "EXCEL_KIND_BRACKET":
      return ExcelKindPayload.EXCEL_KIND_BRACKET;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ExcelKindPayload.UNRECOGNIZED;
  }
}

export function excelKindPayloadToJSON(object: ExcelKindPayload): string {
  switch (object) {
    case ExcelKindPayload.EXCEL_KIND_UNKNOWN:
      return "EXCEL_KIND_UNKNOWN";
    case ExcelKindPayload.EXCEL_KIND_ENTRY_PLAYER:
      return "EXCEL_KIND_ENTRY_PLAYER";
    case ExcelKindPayload.EXCEL_KIND_BRACKET:
      return "EXCEL_KIND_BRACKET";
    case ExcelKindPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** 엑셀 출력 요청 */
export interface ExcelExportRequestPayload {
  /** 엑셀 종류 */
  kind: ExcelKindPayload;
  /** 대회 고유 id (두 종류 모두 대회 단위로 뽑는다) */
  tournamentId: string;
}

/**
 * 엑셀 출력 응답
 *
 * 파일을 서버에 남기지 않고 **응답 본문에 실어** 내려준다 —
 * 다운로드 경로를 열지 않으므로 관리자 토큰 뒤에서만 파일이 나간다.
 * JSON transcoding 에서 `content` 는 base64 문자열로 나간다.
 */
export interface ExcelExportResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 내려받을 때 쓸 파일명 (서버가 대회명 · 날짜로 만든다) */
  fileName: string;
  /** 엑셀 파일 내용 (xlsx) */
  content: Uint8Array;
}

function createBaseExcelExportRequestPayload(): ExcelExportRequestPayload {
  return { kind: 0, tournamentId: "" };
}

export const ExcelExportRequestPayload: MessageFns<ExcelExportRequestPayload> = {
  encode(message: ExcelExportRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.tournamentId !== "") {
      writer.uint32(18).string(message.tournamentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExcelExportRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExcelExportRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExcelExportRequestPayload {
    return {
      kind: isSet(object.kind) ? excelKindPayloadFromJSON(object.kind) : 0,
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
    };
  },

  toJSON(message: ExcelExportRequestPayload): unknown {
    const obj: any = {};
    if (message.kind !== 0) {
      obj.kind = excelKindPayloadToJSON(message.kind);
    }
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExcelExportRequestPayload>, I>>(base?: I): ExcelExportRequestPayload {
    return ExcelExportRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExcelExportRequestPayload>, I>>(object: I): ExcelExportRequestPayload {
    const message = createBaseExcelExportRequestPayload();
    message.kind = object.kind ?? 0;
    message.tournamentId = object.tournamentId ?? "";
    return message;
  },
};

function createBaseExcelExportResponsePayload(): ExcelExportResponsePayload {
  return { result: undefined, fileName: "", content: new Uint8Array(0) };
}

export const ExcelExportResponsePayload: MessageFns<ExcelExportResponsePayload> = {
  encode(message: ExcelExportResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.fileName !== "") {
      writer.uint32(18).string(message.fileName);
    }
    if (message.content.length !== 0) {
      writer.uint32(26).bytes(message.content);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExcelExportResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExcelExportResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.content = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExcelExportResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
      content: isSet(object.content) ? bytesFromBase64(object.content) : new Uint8Array(0),
    };
  },

  toJSON(message: ExcelExportResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.content.length !== 0) {
      obj.content = base64FromBytes(message.content);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExcelExportResponsePayload>, I>>(base?: I): ExcelExportResponsePayload {
    return ExcelExportResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExcelExportResponsePayload>, I>>(object: I): ExcelExportResponsePayload {
    const message = createBaseExcelExportResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.fileName = object.fileName ?? "";
    message.content = object.content ?? new Uint8Array(0);
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
